module.exports = __webpack_public_path__ + "media/images/logo-squirrel-only-89a824a0aa0d841c7ecf8680b8e73ed8.png";